import { render, staticRenderFns } from "./AnalyticsNews.vue?vue&type=template&id=0ea37477"
import script from "./AnalyticsNews.vue?vue&type=script&lang=js"
export * from "./AnalyticsNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports